import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';

import { injectNotesTranslations } from '../helpers';

@Component({
  selector: 'rt-note-typing-indicator-message',
  templateUrl: './note-typing-indicator-message.component.html',
  styleUrls: ['./note-typing-indicator-message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class NoteTypingIndicatorMessageComponent {
  private readonly i18n = inject(I18nService);
  protected readonly notesTranslations = injectNotesTranslations();

  @Input() public typingAdmins: Array<{ firstName: string; lastName: string }> = [];

  public get typingAdminsMessage(): string | undefined {
    if (this.typingAdmins.length > 1) {
      return this.i18n.translate(this.notesTranslations.adminsAreTyping);
    } else if (this.typingAdmins.length === 1) {
      const admin = this.typingAdmins[0];
      const adminName = admin.firstName || admin.lastName;
      return this.i18n.translate(this.notesTranslations.adminIsTyping, { adminName });
    }

    return undefined;
  }
}
